var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mensagem.status == 1)?_c('span',[_c('b-button',{staticClass:"float-right ml-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.lerNaoLer()}}},[_c('span',[_c('i',{class:`fa ${_vm.iconBtn}`}),_vm._v(" "+_vm._s(_vm.tituloBtn)+" ")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }